import React from 'react'

const ClassImages = ({ slice }) => {
    return (
        <section className="class-images mb-100 mt-100">
            <div className="container">
                <div className="class-image-grid">
                    <div>
                        <img src={slice.primary.image_1.url} alt={slice.primary.image_1.alt} />
                    </div>
                    <div>
                        <img src={slice.primary.image_2.url} alt={slice.primary.image_2.alt} />
                    </div>
                    <div>
                        <img src={slice.primary.image_3.url} alt={slice.primary.image_3.alt} />
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ClassImages